import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useLanguage } from '../../hooks/useLanguage';

function ComponentViewPopup({ isPopup, setIsPopup, componentData }) {
    const { t } = useLanguage();
    const location = useLocation();
    const [popupActive, setPopupActive] = useState(false);

    useEffect(() => {
        const body = document.body;
        body.style.overflow = isPopup ? 'hidden' : 'auto';
        return () => {
        body.style.overflow = 'auto';
        };
    }, [isPopup]);

    useEffect(() => {
        let timeout;
        if (isPopup) {
        timeout = setTimeout(() => {
            setPopupActive(true);
        }, 100);
        } else {
        setPopupActive(false);
        }
        return () => clearTimeout(timeout);
    }, [isPopup]);

    useEffect(() => {
        document.body.style.overflow = 'auto';
    }, [location]);

    const handleClose = (e) => {
        e.preventDefault();
        setIsPopup(false);
    };

    // 딤 배경 클릭 핸들러
    const handleBackgroundClick = (e) => {
        if (e.target.className === 'popup-box-component') {
        setIsPopup(false);
        }
    };

    // 이미지 새창 열기 함수
    // const openImagePopup = (imageUrl) => {
    //     const screenWidth = window.innerWidth;
    //     const screenHeight = window.innerHeight;
    //     const popupWidth = Math.floor(screenWidth * 0.6);
    //     const popupHeight = Math.floor(screenHeight * 0.6);
    //     const left = Math.floor((screenWidth - popupWidth) / 2);
    //     const top = Math.floor((screenHeight - popupHeight) / 2);

    //     const popup = window.open(
    //     '', 
    //     'imagePopup', 
    //     `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,resizable=yes`
    //     );
        
    //     popup.document.write(`
    //     <!DOCTYPE html>
    //     <html>
    //         <head>
    //         <title>이미지 보기</title>
    //         <style>
    //             body {
    //             margin: 0;
    //             padding: 0;
    //             display: flex;
    //             justify-content: center;
    //             align-items: center;
    //             background-color: #000;
    //             min-height: 100vh;
    //             box-sizing: border-box;
    //             }
    //             img {
    //             max-width: 100%;
    //             max-height: 100%;
    //             object-fit: contain;
    //             background-color: #000;
    //             }
    //         </style>
    //         </head>
    //         <body>
    //         <img src="${imageUrl}" alt="상세 이미지" onload="window.focus();" />
    //         </body>
    //     </html>
    //     `);
        
    //     popup.document.close();
    // };

    if (isPopup)
        return (
        <div 
            className="popup-box-component"
            onClick={handleBackgroundClick}
        >
            <div className={`box content m ${popupActive ? 'active' : ''}`}>
            <div className="popup_container" style={{height: '100vh'}}>
                <div className='close_btn_con'>
                <button 
                    type="button" 
                    className="close_btn"
                    onClick={handleClose}
                />
                </div>

                <div className='pop_component_title'>
                <h3><span className="t_yellow_text">{t('default')} </span>{t('components')}</h3>
                </div>

                <div className="component_popup_grid">
                {componentData && componentData.map((component, index) => (
                    <div 
                        key={index}
                        className="component_item"
                        // onClick={() => openImagePopup(component.goods_image[0])}
                    >
                        <div className="component_image">
                            <img 
                            src={component.goods_image[0]} 
                            alt={component.product_name || "구성품"} 
                            loading="lazy"
                            />
                            <span className="component_image_num">x1</span>
                        </div>
                        <div className="component_name_box">
                            <p>PAVO Anamorphic 2X 180mm T2.8</p>
                        </div>

                    </div>
                ))}
                </div>

                <div className='pop_component_btn'>
                <button
                    type="button"
                    className="default_btn yellow"
                    onClick={handleClose}
                    style={{width: '100%'}}
                >
                    {t('confirm')}
                </button>
                </div>
            </div>
            </div>
        </div>
        );

    return null;
}

export default ComponentViewPopup;